import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/sprite.svg'


const _hoisted_1 = _imports_0 + '#logo-new'
const _hoisted_2 = { class: "login" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "login__container" }
const _hoisted_5 = {
  key: 0,
  class: "field__error-text"
}
const _hoisted_6 = {
  key: 0,
  class: "field__error-text"
}

import Input from "@/UI/Input.vue";
  import { computed, ref } from "vue";
  import useVuelidate from "@vuelidate/core";
  import { required, helpers } from "@vuelidate/validators";
  import router from "@/router";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

  const model = ref({
    login: "",
    password: "",
  });

  const rules = computed(() => ({
    login: {
      required: helpers.withMessage("Обязательное поле", required),
    },
    password: {
      required: helpers.withMessage("Обязательное поле", required),
    },
  }));

  const v$ = useVuelidate(rules, model);

  const submit = async () => {
    const isValid = await v$.value.$validate();

    if (isValid) {
      // console.log("Отправить");
      router.push("/catalog-menu");
    }
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_2, [
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("form", _hoisted_4, [
        _cache[2] || (_cache[2] = _createElementVNode("svg", {
          class: "login__logo",
          width: "325",
          height: "83"
        }, [
          _createElementVNode("use", { "xlink:href": _hoisted_1 })
        ], -1)),
        _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "login__title" }, "Вход", -1)),
        _createElementVNode("div", {
          class: _normalizeClass(["field", { 'field--error': _unref(v$).login.$error }])
        }, [
          _createVNode(Input, {
            type: "text",
            placeholder: "Логин",
            modelValue: model.value.login,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.value.login) = $event)),
            isError: _unref(v$).login.$error
          }, null, 8, ["modelValue", "isError"]),
          (_unref(v$).login.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(v$).login.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["field", { 'field--error': _unref(v$).password.$error }])
        }, [
          _createVNode(Input, {
            type: "password",
            placeholder: "Пароль",
            modelValue: model.value.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.value.password) = $event)),
            isError: _unref(v$).password.$error
          }, null, 8, ["modelValue", "isError"]),
          (_unref(v$).password.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(v$).password.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("button", {
          class: "login__btn btn btn--green",
          onClick: submit
        }, " Продолжить ")
      ])
    ])
  ]))
}
}

})